// @ts-nocheck
import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[mdCollapse]',
})
export class CollapseDirective {
  @Input() mdCollapse?: string | null;

  @HostListener('click', ['$event'])
  click(e: { currentTarget: any }) {
    const target$ = $(this.mdCollapse || '');
    const isCollapsing = target$.is('.show');
    target$.collapse('toggle');
    $(e.currentTarget).attr('aria-expanded', (!isCollapsing).toString());
  }
}
